export const scrollToSection = (target) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -56, duration: 1.5 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};
